"use client";

import { useFavoriteIds, useToggleFavorite } from "@/hooks/favorite-hooks";
import { useGetCurrentUser } from "@/hooks/auth-hook";
import { Heart } from "lucide-react";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";

export default function FavoriteButton({
  propertyId,
  className = "",
}: {
  propertyId: string;
  className?: string;
}) {
  const locale = useLocale();
  const router = useRouter();
  const { data: user } = useGetCurrentUser();
  const isLoggedIn = !!user?.user;

  const { data: ids } = useFavoriteIds(isLoggedIn);
  const toggle = useToggleFavorite();

  const favorited = !!ids?.includes(propertyId);

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn) {
      router.push(`/${locale}/auth/login`);
      return;
    }
    toggle.mutate(propertyId);
  };

  return (
    <button
      onClick={onClick}
      aria-label="favorite"
      className={`group/fav grid place-items-center size-9 rounded-full bg-white/90 backdrop-blur shadow-md hover:bg-white transition-all active:scale-90 cursor-pointer ${className}`}
    >
      <Heart
        size={18}
        className={`transition-all ${
          favorited
            ? "fill-red-500 text-red-500"
            : "text-slate-500 group-hover/fav:text-red-500"
        }`}
      />
    </button>
  );
}
